export enum DialogImage {
  EMAIL_SENT,
  GRAM_UPGRADED,
  INSUFFICIENT_BALANCE,
  MONEY_TRANSFERRED,
  ORDER_COMPLETED,
  PASSWORD_CHANGED,
  PAYMENT_TRANSFERRED,
  PLAN_CANCELED,
  USER_CREATED,
}

export const dialogImageList = [
  {
    type: DialogImage.EMAIL_SENT,
    fileName: "dlg_email_sent.svg",
  },
  {
    type: DialogImage.GRAM_UPGRADED,
    fileName: "dlg_gram_upgraded.svg",
  },
  {
    type: DialogImage.INSUFFICIENT_BALANCE,
    fileName: "dlg_insufficient_balance.svg",
  },
  {
    type: DialogImage.MONEY_TRANSFERRED,
    fileName: "dlg_money_transfered.svg",
  },
  {
    type: DialogImage.ORDER_COMPLETED,
    fileName: "dlg_order_completed.svg",
  },
  {
    type: DialogImage.PASSWORD_CHANGED,
    fileName: "dlg_password_changed.svg",
  },
  {
    type: DialogImage.PAYMENT_TRANSFERRED,
    fileName: "dlg_payment_transfered.svg",
  },
  {
    type: DialogImage.PLAN_CANCELED,
    fileName: "dlg_plan_canceled.svg",
  },
  {
    type: DialogImage.USER_CREATED,
    fileName: "dlg_user_created.svg",
  },
];

export const getDialogImageFileName = (dialogImage: DialogImage) =>
  dialogImageList.find((item) => item.type == dialogImage).fileName;
